import styled from 'styled-components';
import color from '../utils/style/color';

const Hr = styled.hr`
  height: 1px;
  background-color: ${color.gray.xxBright};
  border: 0;
  margin: 0;
  padding: 0;
`;

export default Hr;
